/**
 * @generated SignedSource<<e06cf0de02a02f5f42e77c496980e6a1>>
 * @relayHash 7d2c1f8e5b9684731e5713e07f73fc9f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d37362be06a6b3aae26e24a239f603fc7b91f3abcd57752080589e5fb224d266

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JourneyConfigurationPageQuery } from './JourneyConfigurationPageQuery.graphql';

import isValidationFGEnabled_provider from '@atlassian/jira-relay-provider/src/jira-journey-builder-improve-validation.relayprovider';
import isConditionsFGEnabled_provider from '@atlassian/jira-relay-provider/src/jsm-journey-builder-condition-smart-value.relayprovider';

const node: PreloadableConcreteRequest<JourneyConfigurationPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "d37362be06a6b3aae26e24a239f603fc7b91f3abcd57752080589e5fb224d266",
    "metadata": {},
    "name": "JourneyConfigurationPageQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjirajourneybuilderimprovevalidationrelayprovider": isValidationFGEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmjourneybuilderconditionsmartvaluerelayprovider": isConditionsFGEnabled_provider
    }
  }
};

export default node;
